import { Dropdown } from "react-bootstrap";
import React,{useCallback, useContext, useEffect, useState} from "react";

import Tooltip from '@mui/material/Tooltip';
import RestartAlt from '@mui/icons-material/RestartAlt';
import { productionService } from "../../services/productionService";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { useLocation, useNavigate ,Link} from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import LogicContext from "../../Context/LogicContext";
import { isArray } from "lodash";
import { productionSetupService } from "../../services/productionSetupservice";
import { SetProdSetUpAtomData, GetProdSetUpAtomData } from "../../store/productionSetupAtom";

const columns = [
  {
    title: 'Id',
    key: 'Item_Id',
    dataIndex: 'Item_Id',
  className: "text-primary",
  sorter: (a, b) => (a?.Item_Id ?? '') - (b?.Item_Id ?? '')
  },

  {
    title: 'Name',
    dataIndex: 'item_Name',
  sorter: (a, b) => (a?.item_Name ?? '').localeCompare(b?.item_Name ?? '')
  },
    
    
  {
    title: "SKU",
    dataIndex: "Item_Sku",
    sorter: (a, b) => (a?.Item_Sku ?? '').localeCompare(b?.Item_Sku ?? '')
  },
    
  {
    title: "Category",
    dataIndex: "Item_Category_Name",
    sorter: (a, b) => (a?.Item_Category_Name ?? '').localeCompare(b?.Item_Category_Name ?? '')
  },

  {
    title: "Required Qty",
    dataIndex: "No_of_Required_Item",
    sorter: (a, b) => (a?.No_of_Required_Item ?? '') - (b?.No_of_Required_Item ?? ''),
      render: (record)=> <span> {formatCustomNumber(record)} </span>

  },

];



function ProductionSetupPage() {

  const { register, setValue, getValues,  handleSubmit, reset, formState: { errors }} = useForm();

    const [prodSetupList, setProdSetupList] = useState([]);
    const setProdSetupAtom = SetProdSetUpAtomData();
    const getProdSetupAtom = GetProdSetUpAtomData();
     const navigate = useNavigate();
    const { pathname } = useLocation();
    var url = pathname.split("/");
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];
      const [itemSelected, setItemSelected] = useState([]);
        const logicContext = useContext(LogicContext);

          const [searchText, setSearchText] = useState('');
        
      
  
    useEffect(()=> {
      if(getProdSetupAtom?.production_item_info?.length){
        setProdSetupList(getProdSetupAtom.production_item_info);
      }else{
        loadDataFromServer();
      }

  },[getProdSetupAtom]);
  


    useEffect(()=> {
        if (sessionStorage.getItem('reloadPage') === 'true') {
          sessionStorage.removeItem('reloadPage');
          loadDataFromServer();
        }
    
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[]);


  const loadDataFromServer = ()=>{
    productionSetupService.getProductionSetupList().then((res)=> {
      if( isArray(res?.data?.production_item_info) && res?.data?.production_item_info?.length){
        setProdSetupAtom(res.data);
        setProdSetupList(res.data.production_item_info);
      }
     }).catch((err)=> {
      logicContext.showToast("data not loaded!", "");
     });
  }

  function selectedTableItems(itemList) {
    setItemSelected(itemList);
  }


  function handleRowClick(data) {
    const id = data["Item_Id"];
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`
    );
  }


  const searchByDate = async (event) => {
      const formData = getValues();
      const response = await productionService.productionListByDate(formData);
      if (response?.data?.length) {
        setProdSetupList(response?.data);
      } else {
        logicContext.showToast("No result found", "");
        setProdSetupList([]);
      }
    };
  

      const handleTableSearch = useCallback(
        (text) => {
          setSearchText(text);
    
          if (text.trim() === '') {
            setProdSetupList(getProdSetupAtom?.production_item_info || []);
            return;
          }
    
          const searchTerm = text.toLowerCase();
          const filtered = (getProdSetupAtom?.production_item_info || []).filter(credit =>
            Object.values(credit).some(value => value?.toString().toLowerCase().includes(searchTerm))
          );
    
          setProdSetupList(filtered);
        },
        [getProdSetupAtom]
      );
    

        const onClearInput = useCallback(() => {
          setSearchText('');
          setProdSetupList(getProdSetupAtom?.production_item_info || []);
        }, [getProdSetupAtom]);
  
 


    return ( 
        <>
           <section className=" py-4 px-2    md:flex justify-between ">
       
       <div className="flex">
       {/* <div className=" mt-1  rounded bg-filterColor pr-4 -ml-2 ">
            <Dropdown>
                <Dropdown.Toggle
                  style={{
                    backgroundColor: "#E5E5E5",
                    border: "none",
                    color: "#45444B",
                    fontSize: "12px",
                    height: "35px",
                  }}
                  id="dropdown-basic"
                >
                  FILTER BY
                </Dropdown.Toggle>
  
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => customFilter(3)}>
                    All
                  </Dropdown.Item>
  
                  <Dropdown.Item onClick={() => customFilter(1)}>
                    Single Items
                  </Dropdown.Item>
  
                  <Dropdown.Item onClick={() => customFilter(2)}>
                    Composite Items
                  </Dropdown.Item>
  
                </Dropdown.Menu>
              </Dropdown>
            </div> */}

            <Tooltip title="Reload">
            <RestartAlt className="cursor ml-2 mt-1" onClick={()=> loadDataFromServer()} color="primary" fontSize="large" />
          </Tooltip>

       
       </div>

             <div className="flex justify-center mt-4">
          <div className="flex flex-col w-full md:w-3/3">
            <input
              type="text"
              placeholder="Search in table"
              value={searchText}
              onChange={e => handleTableSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Backspace') {
                  onClearInput();
                }
              }}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
            />
          </div>
        </div>

            
            <div className="flex  ">
              <div className="flex ">
                {/* <button
                  style={{ color: "#476EF8" }}
                  className="  rounded  text-xs py-[1.8vh] font-[Poppins]   px-4"
                >
                  EXPORT
                </button>
               */}
              </div>
              <Tooltip title="Create new item">
              <Link to={`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`} >
              <button
                style={{ backgroundColor: "#476EF8" }}
                className="  rounded text-white text-sm font-[Poppins] mt-1 py-[1.8vh]  px-3"
              >
                new Setup
              </button>
              </Link>
              </Tooltip>
           
            </div>
          </section>
  

  
          <section>
          <GeneralCustomTable
                            tableHeadList={columns} 
                            tableDataList={prodSetupList}
                          allowCheckBox={true} // show checkBox for each row
                          setSelectedRows={selectedTableItems}
                          rowKey={(record) => record.Sales_Order_Ref_No} // custom key
                          handleRowClick={handleRowClick} />
          </section>
        </>
     );
}

export default ProductionSetupPage;